const VERSION_CURRENT = '13.5.5'

export const verifyVersions = (version: string, versionLimit = VERSION_CURRENT) => {
  if (!version) {
    return false
  }

  const version1Array = versionLimit.split('.').map(Number)
  const version2Array = version.split('.').map(Number)

  for (let i = 0; i < version1Array.length; i += 1) {
    if (version1Array[i] > version2Array[i]) {
      return false
    }
    if (version1Array[i] < version2Array[i]) {
      return true
    }
  }
  return false
}
